export default __webpack_public_path__ + "static/article-finance-winter-finances-3ea747180c4ae8b5b70259f7391dd71b.jpg";